<div class="wrapper">
  <textarea [ngModel]="value" (ngModelChange)="onValueChange($event)" class="form-control"></textarea>
</div>

<div class="info">
  <span><strong>{{ charCount | number }}</strong> characters</span>
  &nbsp;<span>|</span>&nbsp;
  <span><strong>{{ pageCount | number }}</strong> pages/messages</span>
</div>
